import React from "react";
import { SocialMedia } from "../../components";

const Footer = () => {
  const packageInfo = require("../../../package.json");

  return (
    <footer className="border-t border-border bg-footer px-6 pb-8 pt-[50px] text-center">
      <img className="mx-auto mb-4 block w-[min(340px,85%)]" alt="Vismal" src="/images/vismal_contorno_white.png" />
      <SocialMedia />
      <a className="mb-6 mt-3 inline-block text-footer-text no-underline hover:text-footer-hover" href="mailto:vismalmetal@gmail.com">vismalmetal@gmail.com</a>
      <p className="text-eyebrow text-footer-muted">Last update - 03/11/2026 - Bruno Alvarez · Version: {packageInfo.version}</p>
    </footer>
  );
};

export default Footer;
